import React, {useState, useEffect} from 'react';
import {TextArea} from '@react-ui-org/react-ui';
import {PreguntaEncuesta} from './PreguntaEncuesta';
import Switch from 'react-switch';
import {Modal, ModalHeader, ModalBody, ModalFooter} from 'reactstrap';
import {useNavigate} from 'react-router-dom';

export const CrearEncuesta = () => {
	const [Encuesta, setEncuesta] = useState({
		titulo: 'Titulo',
		descripcion: 'Descripcion',
		isRecurrente: false,
		preguntas: [
			{
				id: 1,
				titlo: 'Pregunta ',
				numeroMaximo: 5,
				obligatoria: false,
			},
		],
	});

	const modificarPregunta = (e, id) => {
		let encuestaAxu = {...Encuesta};
		encuestaAxu.preguntas[id - 1].titlo = e.target.value;
		setEncuesta(encuestaAxu);
	};

	const modificarNumeroMaximo = (numMax, id) => {
		let encuestaAxu = {...Encuesta};
		encuestaAxu.preguntas[id - 1].numeroMaximo = numMax;
		setEncuesta(encuestaAxu);
	};

	const preguntaObligatoria = (id) => {
		let encuestaAxu = {...Encuesta};
		// cambiamos el valor de la propiedad obligatoria de la pregunta que coincida con el id
		encuestaAxu.preguntas.map((pregunta) => {
			if (pregunta.id === id) {
				pregunta.obligatoria = !pregunta.obligatoria;
			}
		});
		// actualizamos el estado
		setEncuesta(encuestaAxu);
	};

	const actualizarIDs = (lista) => {
		let idAxu = 1;
		lista.map((pregunta) => {
			pregunta.id = idAxu;
			idAxu++;
		});
	};

	const eliminarPregunnta = (id) => {
		if (Encuesta.preguntas.length > 1) {
			let encuestaAxu = {...Encuesta};
			let idAxu = 1;
			// añadimos todas las preguntas menos la que queremos eliminar ( coincida el id )
			encuestaAxu.preguntas = encuestaAxu.preguntas.filter((pregunta) => pregunta.id !== id);
			actualizarIDs(encuestaAxu.preguntas);
			// actualizamos el estado
			setEncuesta(encuestaAxu);
		}
	};

	const anadirPregunta = () => {
		let encuestaAxu = {...Encuesta};
		// añadimos una pregunta al array
		encuestaAxu.preguntas.push({
			id: encuestaAxu.preguntas[encuestaAxu.preguntas.length - 1].id + 1,
			titlo: 'titulo',
			numeroMaximo: 5,
			obligatoria: false,
		});
		actualizarIDs(encuestaAxu.preguntas);

		// actualizamos el estado
		setEncuesta(encuestaAxu);
	};
	const duplicarRespuesta = (id) => {
		let encuestaAxu = {...Encuesta};
		// recorremos el array y le asignamos un id nuevo a todas las preguntas que sean mayores al id de la pregunta que queremos duplicar

		// añadimos una pregunta al array
		let nuevaPregunta = {
			id: id + 1,
			titlo: encuestaAxu.preguntas[id - 1].titlo,
			numeroMaximo: encuestaAxu.preguntas[id - 1].numeroMaximo,
			obligatoria: encuestaAxu.preguntas[id - 1].obligatoria,
		};
		encuestaAxu.preguntas.splice(id, 0, nuevaPregunta);
		encuestaAxu.preguntas.map((pregunta) => {
			if (pregunta.id > id + 1) {
				pregunta.id++;
			}
		});
		// actualizamos el estado
		setEncuesta(encuestaAxu);
	};

	const [ModalGuardarEncuesta, setModalGuardarEncuesta] = useState(false);
	const navigate = useNavigate();

	const guardarEncuesta = () => {
		// SE GUARDA LA ENCUESTA EN LA BD
		//
		//
		//

		// Se formatea la encuesta
		navigate('/userFeedback');
		setEncuesta({
			titulo: 'Titulo',
			descripcion: 'Descripcion',
			isRecurrente: false,
			preguntas: [
				{
					id: 1,
					titlo: 'Pregunta ',
					numeroMaximo: 5,
					obligatoria: false,
				},
			],
		});
		console.log('Encuesta : ', Encuesta, ' guardada con exito !');
	};

	useEffect(() => {});

	return (
		<>
			<Modal
				centered={true}
				isOpen={ModalGuardarEncuesta}
				toggle={() => setModalGuardarEncuesta(!ModalGuardarEncuesta)}
			>
				<ModalHeader>
					<b>Guardar encuesta</b>
				</ModalHeader>
				<ModalBody>
					<p>¿Desea guarder/realizar la encuesta?</p>
				</ModalBody>
				<ModalFooter>
					<div className='buttons-modal__EliminarEncuesta'>
						<div
							className='button'
							onClick={() => setModalGuardarEncuesta(false)}
						>
							<b>Cancelar</b>
						</div>
						<div
							className='button'
							onClick={() => {
								setModalGuardarEncuesta(false);
								guardarEncuesta();
							}}
						>
							<b>Aceptar</b>
						</div>
					</div>
				</ModalFooter>
			</Modal>
			<div className='preguntas'>
				<div className='contentCreadorEncuestas'>
					<div className='creadorEncuestas'>
						<div className='tituloEncuesta'>
							<div className='inputFechaFacturas '>
								<input
									type='text'
									placeholder='Titulo de la encuesta'
									onChange={(e) =>
										setEncuesta({...Encuesta, titulo: e.target.value})
									}
								/>
							</div>
						</div>
						<div className='descripcionEncuesta'>
							<div className='inputFechaFacturas '>
								<TextArea
									Id='textArea'
									placeholder={'Descripcion de la encuesta'}
									onChange={(e) =>
										setEncuesta({...Encuesta, descripcion: e.target.value})
									}
									fullWidth={true}
								/>
							</div>
						</div>
						<div className='encuestaRecurrente '>
							<div className='selecctorRecurrencia'>
								<div className='centrador'>¿ La encuesta va ser recurrente ?</div>
								<Switch
									onChange={() =>
										setEncuesta({
											...Encuesta,
											isRecurrente: !Encuesta.isRecurrente,
										})
									}
									checked={Encuesta.isRecurrente}
									onColor='#23C290'
									uncheckedIcon={false}
								/>
							</div>
							{Encuesta.isRecurrente && (
								<div className='frecuenciaRecurrenciaEncuesta'>
									Definir tipo de recurrencia
								</div>
							)}
						</div>
					</div>
				</div>
				<div className='listaPreguntas'>
					{Encuesta.preguntas.map((pregunta, key) => (
						<PreguntaEncuesta
							key={pregunta.id}
							Id={pregunta.id}
							pregunta={pregunta}
							modificarPregunta={modificarPregunta}
							modificarNumeroMaximo={modificarNumeroMaximo}
							duplicarRespuesta={duplicarRespuesta}
							preguntaObligatoria={preguntaObligatoria}
							eliminarPregunnta={eliminarPregunnta}
							numeroMaximoPuntuacion={10}
						/>
					))}
				</div>
				<div className='contentAnadirPregunta'>
					<div
						className='buttonAddPregunta'
						onClick={anadirPregunta}
					>
						<div className='centrador'>
							<svg
								xmlns='http://www.w3.org/2000/svg'
								width='36'
								height='36'
								fill='currentColor'
								className='bi bi-plus-circle-fill'
								viewBox='0 0 16 16'
							>
								<path d='M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM8.5 4.5a.5.5 0 0 0-1 0v3h-3a.5.5 0 0 0 0 1h3v3a.5.5 0 0 0 1 0v-3h3a.5.5 0 0 0 0-1h-3v-3z' />
							</svg>
						</div>
					</div>
					<div
						className='buttonAddPregunta'
						onClick={() => setModalGuardarEncuesta(!ModalGuardarEncuesta)}
					>
						<div className='centrador'>
							<svg
								xmlns='http://www.w3.org/2000/svg'
								width='36'
								height='36'
								fill='currentColor'
								className='bi bi-check-circle'
								viewBox='0 0 16 16'
							>
								<path d='M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z' />
								<path d='M10.97 4.97a.235.235 0 0 0-.02.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-1.071-1.05z' />
							</svg>
						</div>
					</div>
				</div>
			</div>
		</>
	);
};
